const MONTHLY = 1;
const SEMI_MONTHLY = 2;
const DAILY = 3;
const WEEKLY = 4;

const PAYROLL_FREQUENCY = {
    MONTHLY: { id: MONTHLY, description: "Monthly" },
    WEEKLY: { id: SEMI_MONTHLY, description: "Semi-Monthly" },
    DAIL: { id: WEEKLY, description: "Weekly" },
    SEMI_MONTHLY: { id: DAILY, description: "Daily" }
};

const PAYROLL_CONSTANTS = { PAYROLL_FREQUENCY };

export default PAYROLL_CONSTANTS;
